import {CSRF_HEADER} from '@/utils/constant';

export function getCsrfToken() {
  const header = document?.querySelector(`meta[name=${CSRF_HEADER}]`) as HTMLMetaElement | null;
  return header?.content || 'missing';
}
